import React, { memo, useMemo } from 'react';

import { Box, Typography } from '@mui/material';
import BadgeCDS, { BadgeColorVariant, BadgeType } from '@sharedCR/coreDesignSystem/BadgeCDS';
import PopTipCDS from '@sharedCR/coreDesignSystem/PopTipCDS';
import _ from 'lodash';
import PropTypes from 'prop-types';

import { ACTOR_TYPE_BY_NAME, ActorType, AI_ATTRIBUTION_BADGE_LABEL } from 'constants/aiAttribution';
import { PopperPlacementType } from 'constants/popover';

import {
  badgeWrapperStyles,
  tooltipRowStyles,
  tooltipTitleStyles,
  tooltipValueStyles,
} from './AiAttributionBadge.styles';

const AiAttributionBadge = ({ actorType, aiProcessId = null, aiProcessExecutionId = null }) => {
  const tooltipContent = useMemo(() => {
    const rows = [
      { label: 'Process', value: aiProcessId },
      { label: 'Run', value: aiProcessExecutionId },
    ].filter(row => !_.isNil(row.value));

    return (
      <Box>
        <Typography sx={tooltipTitleStyles} variant="bold12">
          AI-authored
        </Typography>
        {rows.map(row => (
          <Box key={row.label} sx={tooltipRowStyles}>
            <Typography sx={tooltipValueStyles} variant="regular12">
              {`${row.label}: ${row.value}`}
            </Typography>
          </Box>
        ))}
      </Box>
    );
  }, [aiProcessId, aiProcessExecutionId]);

  if ((ACTOR_TYPE_BY_NAME[actorType] ?? actorType) !== ActorType.AI_PROCESS) {
    return null;
  }

  return (
    <PopTipCDS arrow placement={PopperPlacementType.TOP} title={tooltipContent}>
      <Box sx={badgeWrapperStyles}>
        <BadgeCDS
          colorVariant={BadgeColorVariant.PURPLE}
          type={BadgeType.SIDEBAR}
          value={AI_ATTRIBUTION_BADGE_LABEL}
        />
      </Box>
    </PopTipCDS>
  );
};

AiAttributionBadge.propTypes = {
  actorType: PropTypes.oneOf([...Object.values(ActorType), ...Object.keys(ACTOR_TYPE_BY_NAME)]),
  aiProcessId: PropTypes.string,
  aiProcessExecutionId: PropTypes.string,
};

export default memo(AiAttributionBadge);
